function findSectionIndexByPageNumber(tocArray, pageNumber) {
  let resutIndex = -1;

  for (let i = 0; i < tocArray.length; i += 1) {
    if (pageNumber >= +tocArray[i].page) {
      resutIndex = i;

      // Check if there's a next section and the pageNumber is before the next section
      if (i + 1 < tocArray.length && pageNumber < +tocArray[i + 1].page) break;
    }
  }

  return resutIndex;
}

export default function getSectionFromTableOfContentsByPage(flyer, pageNumber) {
  if (!flyer.settings) return undefined;
  const { table_of_contents } = flyer.settings;
  if (!Array.isArray(table_of_contents)) return undefined;

  return table_of_contents[findSectionIndexByPageNumber(table_of_contents, +pageNumber)];
}
